// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════════════════════
   CustomerV2Preview.css
   ═══════════════════════════════════════════════════════════════════ */

/* ── Page shell ──────────────────────────────────────────────────── */
.cpv__main {
  margin-top: 70px;
  margin-bottom: 70px;
  box-sizing: border-box;
  width: 100%;
  padding-inline: 1.5rem;
  min-height: calc(100vh - 140px);
}

/* ── Grid root ───────────────────────────────────────────────────── */
.cpv__grid-root {
  display: grid;
  gap: 1rem;
  grid-template-columns: 1fr;
  grid-template-areas:
    "header"
    "stats"
    "info"
    "billing"
    "detail";
}

.cpv-header-cards{
  display: flex;
  justify-content: space-between;
  align-items: center;
}

@media (min-width: 1024px) {
  .cpv__grid-root {
    grid-template-columns: 320px 1fr;
    grid-template-areas:
      "header  header"
      "stats   stats"
      "info    detail"
      "billing detail";
  }
}

.cpv__area-header {
  grid-area: header;
}
.cpv__area-stats {
  grid-area: stats;
}
.cpv__area-info {
  grid-area: info;
}
.cpv__area-detail {
  grid-area: detail;
}
.cpv__area-billing {
  grid-area: billing;
}

/* ── Card base ───────────────────────────────────────────────────── */
.cpv__card {
  border-radius: 28px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  background-color: rgba(255, 255, 255, 0.88);
  padding: 1.25rem;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.06);
  backdrop-filter: blur(24px);
  align-self: flex-start;
}

/* ── Loader ──────────────────────────────────────────────────────── */
.cpv__full-loader {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
}

.cpv__spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #e2e8f0;
  border-top-color: #3b6ef6;
  border-radius: 50%;
  animation: cpv-spin 0.75s linear infinite;
}

@keyframes cpv-spin {
  to {
    transform: rotate(360deg);
  }
}

/* ── Header card ─────────────────────────────────────────────────── */
.cpv__header-card {
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: auto auto;
  grid-template-areas:
    "left          btn"
    "outstanding   outstanding";
  gap: 1rem;
  align-items: start;

  border-radius: 28px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  background-color: rgba(255, 255, 255, 0.88);
  padding: 1rem;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.06);
  backdrop-filter: blur(12px);
}

@media (min-width: 860px) {
  .cpv__header-card {
    grid-template-columns: 1fr auto auto;
    grid-template-rows: 1fr;
    grid-template-areas: "left outstanding btn";
    align-items: center;
  }
}

.cpv__header-left {
  grid-area: left;
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}

.cpv__avatar {
  flex-shrink: 0;
  width: 68px;
  height: 68px;
  border-radius: 14px;
  background: #eef1fb;
  color: #3b6ef6;
  font-weight: 700;
  font-size: 1.3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 0.5px;
}

.cpv__header-meta {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.cpv__customer-name {
  margin: 0;
  font-size: 1.3rem;
  font-weight: 700;
  color: #0f172a;
}

.cpv__contact-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.85rem;
}

.cpv__contact-item {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.82rem;
  color: #475569;
}

.cpv__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  margin-top: 0.15rem;
}

.cpv__tag {
  padding: 0.18rem 0.6rem;
  border-radius: 999px;
  border: 1px solid #cbd5e1;
  font-size: 0.7rem;
  font-weight: 600;
  color: #334155;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.cpv__tag--warning {
  border-color: #fcd34d;
  background: #fef9c3;
  color: #92400e;
}

/* ── Outstanding ─────────────────────────────────────────────────── */
.cpv__outstanding {
  grid-area: outstanding;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 190px;
}

.cpv__outstanding-label {
  font-size: 0.68rem;
  font-weight: 700;
  color: #94a3b8;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.cpv__outstanding-value {
  font-size: 1.55rem;
  font-weight: 800;
  color: #0f172a;
  line-height: 1.15;
}

.cpv__outstanding-sub {
  font-size: 0.76rem;
  color: #64748b;
}

.cpv__payable-notes {
  display: flex;
  flex-direction: column;
  gap: 0.18rem;
  margin-top: 0.2rem;
}

.cpv__note {
  font-size: 0.78rem;
  font-weight: 500;
}
.cpv__note--orange {
  color: #d97706;
}
.cpv__note--green {
  color: #16a34a;
}

/* ── Stat cards ──────────────────────────────────────────────────── */
.cpv__stats-row {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.75rem;
}

@media (min-width: 600px) {
  .cpv__stats-row {
    grid-template-columns: repeat(4, 1fr);
  }
}

.cpv__stat-card {
  display: flex;
  flex-direction: column;
  gap: 0.22rem;
  border-radius: 24px;
  border: 1px solid #f1f5f9;
  background: #fff;
  padding: 1.25rem;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.04);
}

.cpv__stat-label {
  font-size: 0.63rem;
  font-weight: 700;
  color: #94a3b8;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.cpv__stat-value {
  font-size: 1rem;
  font-weight: 800;
  color: #0f172a;
  line-height: 1.2;
}

.cpv__stat-sub {
  font-size: 0.7rem;
  color: #64748b;
}

/* ── Section title ───────────────────────────────────────────────── */
.cpv__section-title {
  font-size: 0.68rem;
  font-weight: 700;
  color: #94a3b8;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin: 0 0 1rem 0;
}

/* ── Info rows ───────────────────────────────────────────────────── */
.cpv__info-row {
  display: flex;
  flex-direction: column;
  gap: 0.08rem;
  padding: 0.5rem 0;
  border-bottom: 1px solid #f1f5f9;
}

.cpv__info-row:last-of-type {
  border-bottom: none;
}

.cpv__info-label {
  font-size: 0.7rem;
  color: #94a3b8;
  font-weight: 500;
}

.cpv__info-value {
  font-size: 0.86rem;
  color: #0f172a;
  font-weight: 600;
}

.cpv__map-link {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  margin-top: 0.7rem;
  color: #3b6ef6;
  font-size: 0.8rem;
  font-weight: 600;
  text-decoration: none;
}

.cpv__map-link:hover {
  text-decoration: underline;
}

/* ── Pill tab strip ──────────────────────────────────────────────── */
.cpv__pill-tabs {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

.cpv__pill-tab {
  padding: 0.5rem 1.1rem;
  border-radius: 14px;
  border: 1.5px solid #e2e8f0;
  background: #ffffff;
  font-size: 0.82rem;
  font-weight: 600;
  color: #64748b;
  cursor: pointer;
  white-space: nowrap;
  transition:
    border-color 0.15s,
    color 0.15s,
    background 0.15s;
}

.cpv__pill-tab.active {
  border-color: #3b6ef6;
  color: #3b6ef6;
  background: #ffffff;
}

.cpv__pill-tab:hover:not(.active) {
  border-color: #94a3b8;
  color: #334155;
}

/* ── Tab panel wrappers ──────────────────────────────────────────── */
.cpv__tab-panel {
  /* no extra styling needed — CPT component has its own shell */
}

.cpv__tab-panel-with-background {
  width: 100%;
  background: white;
  overflow: hidden;
  border-radius: 28px;
  border: 1px solid #f1f5f9;
  box-shadow: 0 14px 35px rgba(15, 23, 42, 0.04);
  padding: 10px;
}
/* ── Overview grid ───────────────────────────────────────────────── */
.cpv__ov-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.75rem;
}

@media (max-width: 700px) {
  .cpv__ov-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 420px) {
  .cpv__ov-grid {
    grid-template-columns: 1fr;
  }
}

.cpv__ov-card {
  display: flex;
  flex-direction: column;
  gap: 0.22rem;
  border-radius: 24px;
  border: 1px solid #f1f5f9;
  background-color: #ffffff;
  padding: 1.25rem;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.04);
}

.cpv__ov-label {
  font-size: 0.63rem;
  font-weight: 700;
  color: #94a3b8;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.cpv__ov-value {
  font-size: 1.05rem;
  font-weight: 800;
  color: #0f172a;
  line-height: 1.2;
}

.cpv__ov-sub {
  font-size: 0.7rem;
  color: #64748b;
}

/* ── Tab empty (used by Loyalty / Wallet loading state) ─────────── */
.cpv__tab-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100px;
  color: #94a3b8;
  font-size: 0.85rem;
}

/* ── Order cell helpers (render fns inside CustomerPaginatedTable) ── */
.cpv__order-id-cell {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.cpv__order-id {
  font-size: 0.86rem;
  font-weight: 700;
  color: #0f172a;
}

.cpv__order-date {
  font-size: 0.72rem;
  color: #94a3b8;
}

.cpv__order-badge {
  display: inline-block;
  padding: 0.15rem 0.55rem;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: capitalize;
  background: #f1f5f9;
  color: #475569;
}

.cpv__order-badge--completed,
.cpv__order-badge--delivered {
  background: #dcfce7;
  color: #16a34a;
}
.cpv__order-badge--pending {
  background: #fef9c3;
  color: #92400e;
}
.cpv__order-badge--cancelled,
.cpv__order-badge--returned {
  background: #fee2e2;
  color: #dc2626;
}

/* ── Coupon cell helpers ─────────────────────────────────────────── */
.cpv__coupon-code {
  font-size: 1rem;
  font-weight: 700;
  color: #3b6ef6;
  letter-spacing: 0.05em;
}

.cpv__coupon-status {
  font-size: 0.7rem;
  font-weight: 600;
  padding: 0.15rem 0.55rem;
  border-radius: 999px;
}

.cpv__coupon-status.active {
  background: #dcfce7;
  color: #16a34a;
}
.cpv__coupon-status.used {
  background: #f1f5f9;
  color: #64748b;
}

/* ── Loyalty tab ─────────────────────────────────────────────────── */
.cpv__loyalty-wrap {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
}

@media (max-width: 600px) {
  .cpv__loyalty-wrap {
    grid-template-columns: 1fr;
  }
}

.cpv__loyalty-tier-card,
.cpv__loyalty-visit-card {
  background: #f8fafc;
  border-radius: 10px;
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.cpv__loyalty-tier-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.cpv__loyalty-tier-name {
  font-size: 1.6rem;
  font-weight: 800;
  color: #0f172a;
}

.cpv__loyalty-badge {
  background: #fef9c3;
  color: #92400e;
  font-size: 0.72rem;
  font-weight: 600;
  padding: 0.2rem 0.6rem;
  border-radius: 999px;
}

.cpv__loyalty-pts {
  font-size: 0.8rem;
  color: #64748b;
}

.cpv__loyalty-bar-bg {
  height: 8px;
  background: #e2e8f0;
  border-radius: 999px;
  overflow: hidden;
  margin-top: 0.25rem;
}

.cpv__loyalty-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, #f59e0b, #ef4444);
  border-radius: 999px;
  transition: width 0.4s ease;
}

.cpv__loyalty-visit-days {
  font-size: 1.6rem;
  font-weight: 800;
  color: #0f172a;
}

/* ── Wallet tab ──────────────────────────────────────────────────── */
.cpv__wallet-wrap {
  display: grid;
  grid-template-columns: 200px 1fr;
  gap: 0.75rem;
  align-items: start;
}

@media (max-width: 600px) {
  .cpv__wallet-wrap {
    grid-template-columns: 1fr;
  }
}

.cpv__wallet-balance-card {
  background: #3b6ef6;
  border-radius: 14px;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  min-height: 140px;
  justify-content: center;
}

.cpv__wallet-bal-label {
  font-size: 0.63rem;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.7);
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.cpv__wallet-bal-value {
  font-size: 1.8rem;
  font-weight: 800;
  color: #ffffff;
}
.cpv__wallet-bal-sub {
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.65);
}

.cpv__wallet-txn-list {
  background: #f8fafc;
  border-radius: 10px;
  padding: 0.5rem 1rem;
  display: flex;
  flex-direction: column;
}

.cpv__wallet-txn-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 0;
  border-bottom: 1px solid #e2e8f0;
}

.cpv__wallet-txn-row:last-child {
  border-bottom: none;
}

.cpv__wallet-txn-title {
  font-size: 0.85rem;
  font-weight: 600;
  color: #0f172a;
}
.cpv__wallet-txn-date {
  font-size: 0.72rem;
  color: #94a3b8;
  margin-top: 0.1rem;
}

.cpv__wallet-txn-amt {
  font-size: 0.9rem;
  font-weight: 700;
}
.cpv__wallet-txn-amt.positive {
  color: #16a34a;
}
.cpv__wallet-txn-amt.negative {
  color: #dc2626;
}

/* ── Billing accordions ──────────────────────────────────────────── */
.cpv__accordion {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  margin-bottom: 0.5rem;
  overflow: hidden;
}

.cpv__accordion-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.8rem 1rem;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.86rem;
  font-weight: 600;
  color: #0f172a;
}

.cpv__accordion-chevron {
  font-size: 1.1rem;
  color: #94a3b8;
  transition: transform 0.2s;
  display: inline-block;
  transform: rotate(90deg);
}

.cpv__accordion-chevron.open {
  transform: rotate(-90deg);
}

.cpv__accordion-body {
  padding: 0.2rem 1rem 0.9rem;
  font-size: 0.82rem;
  color: #475569;
  line-height: 1.65;
  border-top: 1px solid #f1f5f9;
}

.cpv__accordion-body p {
  margin: 0;
}

/* ── Back button ─────────────────────────────────────────────────── */
.cpv__go-back {
  padding: 10px;
  border-radius: 50px;
  border: 1px solid lightgray;
}

/* ── Loyalty Details Card ────────────────────────────────────────── */
.cpv__loyalty-details-card {
  grid-column: 1 / -1;
  border-radius: 28px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  background-color: rgba(255, 255, 255, 0.88);
  padding: 1.25rem;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.06);
  backdrop-filter: blur(24px);
  margin-top: 1rem;
}

.cpv__loyalty-details-title {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: #94a3b8;
  margin: 0 0 1rem 0;
}

.cpv__loyalty-details-grid {
  margin-top: 1.25rem;
  display: grid;
  gap: 0.75rem;
  font-size: 0.875rem;
  color: #475569;
}

@media (min-width: 640px) {
  .cpv__loyalty-details-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.cpv__loyalty-details-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 1rem;
  border: 1px solid #f1f5f9;
  background-color: rgba(248, 250, 252, 0.7);
  padding: 0.75rem 1rem;
}

.cpv__loyalty-details-val {
  font-weight: 600;
  color: #0f172a;
}

.cpv__loyalty-details-subval {
  font-size: 0.75rem;
  color: #64748b;
  font-weight: normal;
  margin-left: 0.25rem;
}

.cpv__loyalty-details-divider {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border-top: 1px dashed #e2e8f0;
}

.cpv__loyalty-details-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.cpv__loyalty-details-footer-label {
  font-size: 0.875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  color: #94a3b8;
}

.cpv__loyalty-details-footer-val {
  font-size: 1.5rem;
  font-weight: 700;
  color: #0f172a;
}

/* ── Wallet Activity Section ─────────────────────────────────────── */
.cpv__wallet-activity-card {
  grid-column: 1 / -1;
  border-radius: 28px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  background-color: rgba(255, 255, 255, 0.88);
  padding: 1.25rem;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.06);
  backdrop-filter: blur(24px);
  margin-top: 1rem;
  opacity: 0.5;
  cursor: not-allowed;
}

.cpv__wallet-activity-card * {
  cursor: not-allowed;
}


.cpv__wallet-activity-title {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: #94a3b8;
  margin: 0 0 1rem 0;
}

.cpv__wallet-activity-list {
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.cpv__wallet-activity-item {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  border-radius: 22px;
  border: 1px solid #f1f5f9;
  background-color: rgba(248, 250, 252, 0.6);
  padding: 1rem;
}

@media (min-width: 1024px) {
  .cpv__wallet-activity-item {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
}

.cpv__wallet-activity-item-title {
  font-weight: 600;
  color: #0f172a;
  margin: 0;
}

.cpv__wallet-activity-item-subtitle {
  margin: 0.25rem 0 0 0;
  font-size: 0.875rem;
  color: #64748b;
}

.cpv__wallet-activity-item-right {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.cpv__wallet-activity-amount {
  font-size: 1.125rem;
  font-weight: 700;
  margin: 0;
}

.cpv__wallet-activity-amount.credit {
  color: #059669;
}

.cpv__wallet-activity-amount.debit {
  color: #e11d48;
}

.cpv__wallet-activity-badge {
  display: inline-flex;
  border-radius: 9999px;
  border: 1px solid transparent;
  padding: 0.25rem 0.75rem;
  font-size: 0.75rem;
  font-weight: 600;
}

.cpv__wallet-activity-badge.credit {
  border-color: #a7f3d0;
  background-color: #ecfdf5;
  color: #047857;
}

.cpv__wallet-activity-badge.debit {
  border-color: #fecdd3;
  background-color: #fff1f2;
  color: #be123c;
}


`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/CustomerV2Preview/CustomerV2Preview.css"],"names":[],"mappings":"AAAA;;wEAEwE;;AAExE,uEAAuE;AACvE;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,SAAS;EACT,0BAA0B;EAC1B;;;;;YAKU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE;IACE,gCAAgC;IAChC;;;;sBAIkB;EACpB;AACF;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;;AAEA,uEAAuE;AACvE;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,2CAA2C;EAC3C,gBAAgB;EAChB,8CAA8C;EAC9C,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,+BAA+B;EAC/B,6BAA6B;EAC7B;;+BAE6B;EAC7B,SAAS;EACT,kBAAkB;;EAElB,mBAAmB;EACnB,0CAA0C;EAC1C,2CAA2C;EAC3C,aAAa;EACb,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE;IACE,oCAAoC;IACpC,uBAAuB;IACvB,2CAA2C;IAC3C,mBAAmB;EACrB;AACF;;AAEA;EACE,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,uEAAuE;AACvE;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,uEAAuE;AACvE;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB;;;oBAGkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,uEAAuE;AACvE;EACE,8DAA8D;AAChE;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;EAC9C,aAAa;AACf;AACA,uEAAuE;AACvE;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,sEAAsE;AACtE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA,wEAAwE;AACxE;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,uEAAuE;AACvE;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;;EAEE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA,uEAAuE;AACvE;EACE,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,0BAA0B;EAC1B,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;AACX;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,uEAAuE;AACvE;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,2CAA2C;EAC3C,gBAAgB;EAChB,8CAA8C;EAC9C,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,uEAAuE;AACvE;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,2CAA2C;EAC3C,gBAAgB;EAChB,8CAA8C;EAC9C,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE;IACE,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;EAChC;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,6BAA6B;EAC7B,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB","sourcesContent":["/* ═══════════════════════════════════════════════════════════════════\n   CustomerV2Preview.css\n   ═══════════════════════════════════════════════════════════════════ */\n\n/* ── Page shell ──────────────────────────────────────────────────── */\n.cpv__main {\n  margin-top: 70px;\n  margin-bottom: 70px;\n  box-sizing: border-box;\n  width: 100%;\n  padding-inline: 1.5rem;\n  min-height: calc(100vh - 140px);\n}\n\n/* ── Grid root ───────────────────────────────────────────────────── */\n.cpv__grid-root {\n  display: grid;\n  gap: 1rem;\n  grid-template-columns: 1fr;\n  grid-template-areas:\n    \"header\"\n    \"stats\"\n    \"info\"\n    \"billing\"\n    \"detail\";\n}\n\n.cpv-header-cards{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n@media (min-width: 1024px) {\n  .cpv__grid-root {\n    grid-template-columns: 320px 1fr;\n    grid-template-areas:\n      \"header  header\"\n      \"stats   stats\"\n      \"info    detail\"\n      \"billing detail\";\n  }\n}\n\n.cpv__area-header {\n  grid-area: header;\n}\n.cpv__area-stats {\n  grid-area: stats;\n}\n.cpv__area-info {\n  grid-area: info;\n}\n.cpv__area-detail {\n  grid-area: detail;\n}\n.cpv__area-billing {\n  grid-area: billing;\n}\n\n/* ── Card base ───────────────────────────────────────────────────── */\n.cpv__card {\n  border-radius: 28px;\n  border: 1px solid rgba(255, 255, 255, 0.7);\n  background-color: rgba(255, 255, 255, 0.88);\n  padding: 1.25rem;\n  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.06);\n  backdrop-filter: blur(24px);\n  align-self: flex-start;\n}\n\n/* ── Loader ──────────────────────────────────────────────────────── */\n.cpv__full-loader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 60vh;\n}\n\n.cpv__spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid #e2e8f0;\n  border-top-color: #3b6ef6;\n  border-radius: 50%;\n  animation: cpv-spin 0.75s linear infinite;\n}\n\n@keyframes cpv-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* ── Header card ─────────────────────────────────────────────────── */\n.cpv__header-card {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  grid-template-rows: auto auto;\n  grid-template-areas:\n    \"left          btn\"\n    \"outstanding   outstanding\";\n  gap: 1rem;\n  align-items: start;\n\n  border-radius: 28px;\n  border: 1px solid rgba(255, 255, 255, 0.7);\n  background-color: rgba(255, 255, 255, 0.88);\n  padding: 1rem;\n  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.06);\n  backdrop-filter: blur(12px);\n}\n\n@media (min-width: 860px) {\n  .cpv__header-card {\n    grid-template-columns: 1fr auto auto;\n    grid-template-rows: 1fr;\n    grid-template-areas: \"left outstanding btn\";\n    align-items: center;\n  }\n}\n\n.cpv__header-left {\n  grid-area: left;\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n}\n\n.cpv__avatar {\n  flex-shrink: 0;\n  width: 68px;\n  height: 68px;\n  border-radius: 14px;\n  background: #eef1fb;\n  color: #3b6ef6;\n  font-weight: 700;\n  font-size: 1.3rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  letter-spacing: 0.5px;\n}\n\n.cpv__header-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n}\n\n.cpv__customer-name {\n  margin: 0;\n  font-size: 1.3rem;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.cpv__contact-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.85rem;\n}\n\n.cpv__contact-item {\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n  font-size: 0.82rem;\n  color: #475569;\n}\n\n.cpv__tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n  margin-top: 0.15rem;\n}\n\n.cpv__tag {\n  padding: 0.18rem 0.6rem;\n  border-radius: 999px;\n  border: 1px solid #cbd5e1;\n  font-size: 0.7rem;\n  font-weight: 600;\n  color: #334155;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.cpv__tag--warning {\n  border-color: #fcd34d;\n  background: #fef9c3;\n  color: #92400e;\n}\n\n/* ── Outstanding ─────────────────────────────────────────────────── */\n.cpv__outstanding {\n  grid-area: outstanding;\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  min-width: 190px;\n}\n\n.cpv__outstanding-label {\n  font-size: 0.68rem;\n  font-weight: 700;\n  color: #94a3b8;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.cpv__outstanding-value {\n  font-size: 1.55rem;\n  font-weight: 800;\n  color: #0f172a;\n  line-height: 1.15;\n}\n\n.cpv__outstanding-sub {\n  font-size: 0.76rem;\n  color: #64748b;\n}\n\n.cpv__payable-notes {\n  display: flex;\n  flex-direction: column;\n  gap: 0.18rem;\n  margin-top: 0.2rem;\n}\n\n.cpv__note {\n  font-size: 0.78rem;\n  font-weight: 500;\n}\n.cpv__note--orange {\n  color: #d97706;\n}\n.cpv__note--green {\n  color: #16a34a;\n}\n\n/* ── Stat cards ──────────────────────────────────────────────────── */\n.cpv__stats-row {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 0.75rem;\n}\n\n@media (min-width: 600px) {\n  .cpv__stats-row {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n.cpv__stat-card {\n  display: flex;\n  flex-direction: column;\n  gap: 0.22rem;\n  border-radius: 24px;\n  border: 1px solid #f1f5f9;\n  background: #fff;\n  padding: 1.25rem;\n  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.04);\n}\n\n.cpv__stat-label {\n  font-size: 0.63rem;\n  font-weight: 700;\n  color: #94a3b8;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.cpv__stat-value {\n  font-size: 1rem;\n  font-weight: 800;\n  color: #0f172a;\n  line-height: 1.2;\n}\n\n.cpv__stat-sub {\n  font-size: 0.7rem;\n  color: #64748b;\n}\n\n/* ── Section title ───────────────────────────────────────────────── */\n.cpv__section-title {\n  font-size: 0.68rem;\n  font-weight: 700;\n  color: #94a3b8;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  margin: 0 0 1rem 0;\n}\n\n/* ── Info rows ───────────────────────────────────────────────────── */\n.cpv__info-row {\n  display: flex;\n  flex-direction: column;\n  gap: 0.08rem;\n  padding: 0.5rem 0;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.cpv__info-row:last-of-type {\n  border-bottom: none;\n}\n\n.cpv__info-label {\n  font-size: 0.7rem;\n  color: #94a3b8;\n  font-weight: 500;\n}\n\n.cpv__info-value {\n  font-size: 0.86rem;\n  color: #0f172a;\n  font-weight: 600;\n}\n\n.cpv__map-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  margin-top: 0.7rem;\n  color: #3b6ef6;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.cpv__map-link:hover {\n  text-decoration: underline;\n}\n\n/* ── Pill tab strip ──────────────────────────────────────────────── */\n.cpv__pill-tabs {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n  margin-bottom: 1rem;\n}\n\n.cpv__pill-tab {\n  padding: 0.5rem 1.1rem;\n  border-radius: 14px;\n  border: 1.5px solid #e2e8f0;\n  background: #ffffff;\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: #64748b;\n  cursor: pointer;\n  white-space: nowrap;\n  transition:\n    border-color 0.15s,\n    color 0.15s,\n    background 0.15s;\n}\n\n.cpv__pill-tab.active {\n  border-color: #3b6ef6;\n  color: #3b6ef6;\n  background: #ffffff;\n}\n\n.cpv__pill-tab:hover:not(.active) {\n  border-color: #94a3b8;\n  color: #334155;\n}\n\n/* ── Tab panel wrappers ──────────────────────────────────────────── */\n.cpv__tab-panel {\n  /* no extra styling needed — CPT component has its own shell */\n}\n\n.cpv__tab-panel-with-background {\n  width: 100%;\n  background: white;\n  overflow: hidden;\n  border-radius: 28px;\n  border: 1px solid #f1f5f9;\n  box-shadow: 0 14px 35px rgba(15, 23, 42, 0.04);\n  padding: 10px;\n}\n/* ── Overview grid ───────────────────────────────────────────────── */\n.cpv__ov-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 0.75rem;\n}\n\n@media (max-width: 700px) {\n  .cpv__ov-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n@media (max-width: 420px) {\n  .cpv__ov-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.cpv__ov-card {\n  display: flex;\n  flex-direction: column;\n  gap: 0.22rem;\n  border-radius: 24px;\n  border: 1px solid #f1f5f9;\n  background-color: #ffffff;\n  padding: 1.25rem;\n  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.04);\n}\n\n.cpv__ov-label {\n  font-size: 0.63rem;\n  font-weight: 700;\n  color: #94a3b8;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.cpv__ov-value {\n  font-size: 1.05rem;\n  font-weight: 800;\n  color: #0f172a;\n  line-height: 1.2;\n}\n\n.cpv__ov-sub {\n  font-size: 0.7rem;\n  color: #64748b;\n}\n\n/* ── Tab empty (used by Loyalty / Wallet loading state) ─────────── */\n.cpv__tab-empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100px;\n  color: #94a3b8;\n  font-size: 0.85rem;\n}\n\n/* ── Order cell helpers (render fns inside CustomerPaginatedTable) ── */\n.cpv__order-id-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n}\n\n.cpv__order-id {\n  font-size: 0.86rem;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.cpv__order-date {\n  font-size: 0.72rem;\n  color: #94a3b8;\n}\n\n.cpv__order-badge {\n  display: inline-block;\n  padding: 0.15rem 0.55rem;\n  border-radius: 999px;\n  font-size: 0.7rem;\n  font-weight: 600;\n  text-transform: capitalize;\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.cpv__order-badge--completed,\n.cpv__order-badge--delivered {\n  background: #dcfce7;\n  color: #16a34a;\n}\n.cpv__order-badge--pending {\n  background: #fef9c3;\n  color: #92400e;\n}\n.cpv__order-badge--cancelled,\n.cpv__order-badge--returned {\n  background: #fee2e2;\n  color: #dc2626;\n}\n\n/* ── Coupon cell helpers ─────────────────────────────────────────── */\n.cpv__coupon-code {\n  font-size: 1rem;\n  font-weight: 700;\n  color: #3b6ef6;\n  letter-spacing: 0.05em;\n}\n\n.cpv__coupon-status {\n  font-size: 0.7rem;\n  font-weight: 600;\n  padding: 0.15rem 0.55rem;\n  border-radius: 999px;\n}\n\n.cpv__coupon-status.active {\n  background: #dcfce7;\n  color: #16a34a;\n}\n.cpv__coupon-status.used {\n  background: #f1f5f9;\n  color: #64748b;\n}\n\n/* ── Loyalty tab ─────────────────────────────────────────────────── */\n.cpv__loyalty-wrap {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.75rem;\n}\n\n@media (max-width: 600px) {\n  .cpv__loyalty-wrap {\n    grid-template-columns: 1fr;\n  }\n}\n\n.cpv__loyalty-tier-card,\n.cpv__loyalty-visit-card {\n  background: #f8fafc;\n  border-radius: 10px;\n  padding: 1.25rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.cpv__loyalty-tier-row {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n.cpv__loyalty-tier-name {\n  font-size: 1.6rem;\n  font-weight: 800;\n  color: #0f172a;\n}\n\n.cpv__loyalty-badge {\n  background: #fef9c3;\n  color: #92400e;\n  font-size: 0.72rem;\n  font-weight: 600;\n  padding: 0.2rem 0.6rem;\n  border-radius: 999px;\n}\n\n.cpv__loyalty-pts {\n  font-size: 0.8rem;\n  color: #64748b;\n}\n\n.cpv__loyalty-bar-bg {\n  height: 8px;\n  background: #e2e8f0;\n  border-radius: 999px;\n  overflow: hidden;\n  margin-top: 0.25rem;\n}\n\n.cpv__loyalty-bar-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #f59e0b, #ef4444);\n  border-radius: 999px;\n  transition: width 0.4s ease;\n}\n\n.cpv__loyalty-visit-days {\n  font-size: 1.6rem;\n  font-weight: 800;\n  color: #0f172a;\n}\n\n/* ── Wallet tab ──────────────────────────────────────────────────── */\n.cpv__wallet-wrap {\n  display: grid;\n  grid-template-columns: 200px 1fr;\n  gap: 0.75rem;\n  align-items: start;\n}\n\n@media (max-width: 600px) {\n  .cpv__wallet-wrap {\n    grid-template-columns: 1fr;\n  }\n}\n\n.cpv__wallet-balance-card {\n  background: #3b6ef6;\n  border-radius: 14px;\n  padding: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n  min-height: 140px;\n  justify-content: center;\n}\n\n.cpv__wallet-bal-label {\n  font-size: 0.63rem;\n  font-weight: 700;\n  color: rgba(255, 255, 255, 0.7);\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.cpv__wallet-bal-value {\n  font-size: 1.8rem;\n  font-weight: 800;\n  color: #ffffff;\n}\n.cpv__wallet-bal-sub {\n  font-size: 0.75rem;\n  color: rgba(255, 255, 255, 0.65);\n}\n\n.cpv__wallet-txn-list {\n  background: #f8fafc;\n  border-radius: 10px;\n  padding: 0.5rem 1rem;\n  display: flex;\n  flex-direction: column;\n}\n\n.cpv__wallet-txn-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.75rem 0;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.cpv__wallet-txn-row:last-child {\n  border-bottom: none;\n}\n\n.cpv__wallet-txn-title {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #0f172a;\n}\n.cpv__wallet-txn-date {\n  font-size: 0.72rem;\n  color: #94a3b8;\n  margin-top: 0.1rem;\n}\n\n.cpv__wallet-txn-amt {\n  font-size: 0.9rem;\n  font-weight: 700;\n}\n.cpv__wallet-txn-amt.positive {\n  color: #16a34a;\n}\n.cpv__wallet-txn-amt.negative {\n  color: #dc2626;\n}\n\n/* ── Billing accordions ──────────────────────────────────────────── */\n.cpv__accordion {\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  margin-bottom: 0.5rem;\n  overflow: hidden;\n}\n\n.cpv__accordion-header {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.8rem 1rem;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 0.86rem;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.cpv__accordion-chevron {\n  font-size: 1.1rem;\n  color: #94a3b8;\n  transition: transform 0.2s;\n  display: inline-block;\n  transform: rotate(90deg);\n}\n\n.cpv__accordion-chevron.open {\n  transform: rotate(-90deg);\n}\n\n.cpv__accordion-body {\n  padding: 0.2rem 1rem 0.9rem;\n  font-size: 0.82rem;\n  color: #475569;\n  line-height: 1.65;\n  border-top: 1px solid #f1f5f9;\n}\n\n.cpv__accordion-body p {\n  margin: 0;\n}\n\n/* ── Back button ─────────────────────────────────────────────────── */\n.cpv__go-back {\n  padding: 10px;\n  border-radius: 50px;\n  border: 1px solid lightgray;\n}\n\n/* ── Loyalty Details Card ────────────────────────────────────────── */\n.cpv__loyalty-details-card {\n  grid-column: 1 / -1;\n  border-radius: 28px;\n  border: 1px solid rgba(255, 255, 255, 0.7);\n  background-color: rgba(255, 255, 255, 0.88);\n  padding: 1.25rem;\n  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.06);\n  backdrop-filter: blur(24px);\n  margin-top: 1rem;\n}\n\n.cpv__loyalty-details-title {\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.18em;\n  color: #94a3b8;\n  margin: 0 0 1rem 0;\n}\n\n.cpv__loyalty-details-grid {\n  margin-top: 1.25rem;\n  display: grid;\n  gap: 0.75rem;\n  font-size: 0.875rem;\n  color: #475569;\n}\n\n@media (min-width: 640px) {\n  .cpv__loyalty-details-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n.cpv__loyalty-details-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: 1rem;\n  border: 1px solid #f1f5f9;\n  background-color: rgba(248, 250, 252, 0.7);\n  padding: 0.75rem 1rem;\n}\n\n.cpv__loyalty-details-val {\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.cpv__loyalty-details-subval {\n  font-size: 0.75rem;\n  color: #64748b;\n  font-weight: normal;\n  margin-left: 0.25rem;\n}\n\n.cpv__loyalty-details-divider {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  border-top: 1px dashed #e2e8f0;\n}\n\n.cpv__loyalty-details-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.cpv__loyalty-details-footer-label {\n  font-size: 0.875rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.16em;\n  color: #94a3b8;\n}\n\n.cpv__loyalty-details-footer-val {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n/* ── Wallet Activity Section ─────────────────────────────────────── */\n.cpv__wallet-activity-card {\n  grid-column: 1 / -1;\n  border-radius: 28px;\n  border: 1px solid rgba(255, 255, 255, 0.7);\n  background-color: rgba(255, 255, 255, 0.88);\n  padding: 1.25rem;\n  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.06);\n  backdrop-filter: blur(24px);\n  margin-top: 1rem;\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.cpv__wallet-activity-card * {\n  cursor: not-allowed;\n}\n\n\n.cpv__wallet-activity-title {\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.18em;\n  color: #94a3b8;\n  margin: 0 0 1rem 0;\n}\n\n.cpv__wallet-activity-list {\n  margin-top: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.cpv__wallet-activity-item {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  border-radius: 22px;\n  border: 1px solid #f1f5f9;\n  background-color: rgba(248, 250, 252, 0.6);\n  padding: 1rem;\n}\n\n@media (min-width: 1024px) {\n  .cpv__wallet-activity-item {\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n  }\n}\n\n.cpv__wallet-activity-item-title {\n  font-weight: 600;\n  color: #0f172a;\n  margin: 0;\n}\n\n.cpv__wallet-activity-item-subtitle {\n  margin: 0.25rem 0 0 0;\n  font-size: 0.875rem;\n  color: #64748b;\n}\n\n.cpv__wallet-activity-item-right {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.cpv__wallet-activity-amount {\n  font-size: 1.125rem;\n  font-weight: 700;\n  margin: 0;\n}\n\n.cpv__wallet-activity-amount.credit {\n  color: #059669;\n}\n\n.cpv__wallet-activity-amount.debit {\n  color: #e11d48;\n}\n\n.cpv__wallet-activity-badge {\n  display: inline-flex;\n  border-radius: 9999px;\n  border: 1px solid transparent;\n  padding: 0.25rem 0.75rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.cpv__wallet-activity-badge.credit {\n  border-color: #a7f3d0;\n  background-color: #ecfdf5;\n  color: #047857;\n}\n\n.cpv__wallet-activity-badge.debit {\n  border-color: #fecdd3;\n  background-color: #fff1f2;\n  color: #be123c;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
